import keyMirror from 'keymirror';

export const MOMENT_DATE_FORMAT = 'DD MMMM YYYY';

export const MAX_FIRS_LAST_NAMES_LENGTH = 64;

export const sharedTypes = keyMirror({
	SEND_EVENT_REQUEST: null,
	SEND_EVENT_SUCCESS: null,

	SET_EVENT_SOURCE: null,
	SET_PAGE_SOURCE: null,

	SET_TRIGGER_MESSAGE_PRESENT: null,

	SET_TRIGGER_UPGRADE_MODAL: null,
	SET_FOR_UPGRADE_MODAL_FROM_EXPLANATION: null,
	SET_UPGRADE_MODAL_IDENTIFIER: null,

	SET_THEME: null,

	GET_USER_COLLECTIONS: null,
	GET_USER_COLLECTIONS_SUCCESS: null,
	GET_USER_COLLECTIONS_ERROR: null,

	GET_USER_SUGGESTED_SUBJECTS: null,
	GET_USER_SUGGESTED_SUBJECTS_SUCCESS: null,
	GET_USER_SUGGESTED_SUBJECTS_ERROR: null,

	GET_TFA_DATA: null,
	GET_TFA_DATA_SUCCESS: null,
	GET_TFA_DATA_ERROR: null,
	SET_TFA_CODE: null,
	SET_TFA_CODE_SUCCESS: null,
	SET_TFA_CODE_ERROR: null,
	CLEAR_TFA_STATE: null,
});

export const EVENTS_TYPES = {
	CHAPTER_VIDEO_VIEWED: 'chapter_video_viewed',
	TOPIC_VIDEO_VIEWED: 'topic_video_viewed',
	TOPIC_VIDEO_CLOSED: 'topic_video_closed',
	ANSWER_VIDEO_VIEWED: 'answer_explanation_video_viewed',
	EXPLANATION_VIEWED: 'explanation_viewed',
	UPGRADE_MESSAGE_SEEN: 'upgrade_message_seen',
	EXERCISE_THEORY_VIEWED: 'theory_viewed',
	MANAGE_PACKAGE_BUTTON_CLICKED: 'manage_package_button_clicked',
	SEE_FULL_SUMMARY_BUTTON_CLICKED: 'see_full_summary_button_clicked',
	USP_SEEN: 'usp_seen',
	TOPIC_VIDEO_SHARED: 'topic_video_shared',
	CHAPTER_VIDEO_SHARED: 'chapter_video_shared',
	SONG_SHARED: 'song_shared',
	RESULTS_SHARED: 'result_shared',
	GET_APP_NOTIFICATION_CLICKED: 'get_app_notification_clicked',
	OFFER_VIEWED: 'offer_viewed',
	OFFER_DECLINED: 'offer_declined',
	CANCELLED: 'cancelled',
	CANCELLATION_DEFLECTED: 'cancellation_deflected',
	CANCELLATION_OFFER_ACCEPTED: 'cancellation_offer_accepted',
	CANCELLATION_MONEY_BACK_CLICKED: 'cancellation_moneyback_clicked',
	CANCELLATION_SUBJECT_TOPICS_CLICKED: 'cancellation_subject_topics_clicked',
	CANCELLATION_TRIAL_END_REMINDER_SCHEDULED: 'cancellation_trial_end_reminder_scheduled',
	PUSH_NOTIFICATION_READ: 'push_notification_read',
	LIVE_CLASS_BANNER_VIEWED: 'live_class_banner_seen',
	LIVE_CLASS_BANNER_CLICKED: 'live_class_banner_clicked',
	EXPERIMENT_VARIATION_ASSIGNED: 'experiment_variation_assigned',
	REGISTRATION_PAGE_VIEWED: 'registration_page_viewed',
	SHARED_TOPIC_VIDEO_VISITED: 'shared_topic_video_visited',
	SHARED_CHAPTER_VIDEO_VISITED: 'shared_chapter_video_visited',
	CHOOSE_LEVEL_VIEWED: 'choose_level_viewed',
	PACKAGE_PAGE_VIEWED: 'package_page_viewed',
	SHOP_PAGE_VIEWED: 'shop_page_viewed',
	PAYMENT_INITIATED: 'payment_initiated',
	PAYMENT_FAILED: 'payment_failed',
	LIVE_CLASS_SIGNED_UP: 'live_class_signed_up',
	LIVE_CLASS_CALL_JOINED: 'live_class_call_joined',
	LIVE_CLASS_CALL_LEFT: 'live_class_call_left',
	LIVE_CLASS_FEEDBACK_GIVEN: 'live_class_feedback_given',
	PERSONALISED_FEEDBACK_RATED: 'personalised_feedback_rated',
	SONG_PLAYED: 'song_played',
	LESSON_OVERVIEW_PAGE_VIEWED: 'lesson_overview_page_viewed',
	LESSON_DETAIL_PAGE_VIEWED: 'lesson_detail_page_viewed',
	CONFIRMATION_PAGE_VIEWED: 'confirmation_page_viewed',
	SIGNUP_BANNER_CLICKED: 'signup_banner_clicked',
	PARENT_PAYMENT_MODAL_VIEWED: 'parent_payment_modal_viewed',
	ACQUISITION_CHANNEL_SET: 'acquisition_channel_set',
	IMPACT_BANNER_CLICKED: 'social_impact_banner_clicked',
	START_TOPIC_EXERCISE_CLICKED: 'start_topic_exercise_clicked',
	EXPAND_TOPIC_SUMMARY_CLICKED: 'expand_topic_summary_clicked',
	LAST_CHANCE_RENEWAL_BANNER_BUTTON_CLICKED: 'last_chance_renewal_banner_button_clicked',
	LAST_CHANCE_RENEWAL_PACKAGE_BUTTON_CLICKED: 'last_chance_renewal_package_button_clicked',
	MORE_INFO_BUTTON_CLICKED: 'more_info_button_clicked_wordlist_modal',
	ASK_PARENT_BUTTON_CLICKED: 'ask_parents_button_clicked_wordlist_modal',
	AI_HINT_FEEDBACK: 'feedback_ai_hint',
};

export const SUCCESSFUL_PERCENTAGE_FROM = 55;

export const generateChapterTitle = (title, titleNumber, t) => {
	if (title) return `${titleNumber !== null ? `${titleNumber} · ` : ''}${title}`;
	return `${t('general.chapter')} ${titleNumber || t('general.not_applicable')}`;
};
